module.exports = __webpack_public_path__ + "media/assets/avia/search/tr-plane-78110fb5095c4323d8623cd07adb5cc6.svg";